import { HttpService } from "@/core";
import {ParticipantsRecord,DeleteIds,ParticipantsListReq} from './participants.interface'
export class ParticipantsService{
	static useCreateApi() {
		const api = (data: ParticipantsRecord) =>
		HttpService.axios({
			method: "POST",
			url: "/participate_company_api/add",
			data,
		});
		return HttpService.useRequest(api);
	}
	static useDeleteApi() {
		const api = (data: DeleteIds) =>
		HttpService.axios({
			method: "POST",
			url: "/participate_company_api/delete",
			data,
		});
		return HttpService.useRequest(api);
	}
	static uselistApi() {
		const api = () =>
		HttpService.axios({
			method: "GET",
			url: "/participate_company_api/list",
		});
		return HttpService.useRequest<{ records: ParticipantsRecord[] }>(api);
	}
	static usePageApi() {
    	const api = (params: ParticipantsListReq) =>
		HttpService.axios({
			method: "GET",
			url: "/participate_company_api/page",
			params,
		});
		return HttpService.usePagination<{ records: ParticipantsRecord[] }>(api);
	}
	static useDetailApi() {
	 	const api = (id: string) =>
	    HttpService.axios({
	      method: "GET",
	      url: `/participate_company_api/${id}`,
	    });
	  	return HttpService.useRequest<ParticipantsRecord>(api);
	}
	static useEditApi() {
	  	const api = (id: string, data: ParticipantsRecord) =>
	    HttpService.axios({
	      method: "PUT",
	      url: `/participate_company_api/update`,
	      data,
	    });
	  	return HttpService.useRequest(api);
	}
	
}